module.exports = __webpack_public_path__ + "img/Group 1672@2x.d957fc63.png";